import { Injectable } from '@angular/core';
import { filterNilValue, Query } from '@datorama/akita';
import { filter, map, take } from 'rxjs/operators';
import { AppConfigState, AppConfigStore } from './app-config.store';
import { SbHost, SbPath } from '@models';

@Injectable({ providedIn: 'root' })
export class AppConfigQuery extends Query<AppConfigState> {
    constructor(protected store: AppConfigStore) {
        super(store);
    }
    hasLoaded$ = this.selectLoading().pipe(
        filterNilValue(),
        filter((loading) => loading === false),
        map((loading) => loading === false),
        take(1)
    );

    get useLegacyAccountList() {
        const value = this.getValue().useLegacyAccountList;
        if (typeof value === 'boolean') {
            return value;
        } else if (typeof value === 'string' && value !== 'balance-list') {
            return value === 'true';
        } else if (typeof value === 'string' && value === 'balance-list') {
            return value;
        } else {
            return false;
        }
    }

    get = () => this.getValue();

    get appConfig() {
        return this.getValue();
    }

    public getDropboxRedirectUrl() {
        return this.get().dropboxRedirectUrl;
    }

    /* Todo - move this to private method in data-service when no
    data requests are going through non-generic getData(url: string).
    - why are we using this? */
    public getBaseUrl(path: SbPath, defaultBasePath: SbHost): string {
        const config = this;
        if (path.host) {
            return path.host;
        }
        const hostEnum = path.hostEnum ? path.hostEnum : defaultBasePath;
        return this.getBaseUrlFromHost(hostEnum);
    }

    public getBaseUrlFromHost(hostEnum: SbHost): string {
        const config = this;
        switch (hostEnum) {
            case SbHost.FormConfigBaseUrl:
                return config.get().formConfigBaseUrl;
            case SbHost.GatewayBaseUrl:
                return config.get().gatewayBaseUrl;
            case SbHost.WidgetDataBaseUrl:
                return config.get().widgetDataBaseUrl;
            case SbHost.MockDataBaseUrl:
                return config.get().mockDataBaseUrl;
            case SbHost.LayoutConfigurationBaseUrl:
                return config.get().layoutConfigurationBaseUrl;
            case SbHost.PrivateAssetBaseUrl:
                return config.get().privateAssetBaseUrl;
            case SbHost.GlobalResourceBaseUrl:
                return config.get().globalResourceBaseUrl;
            case SbHost.CategoriesBaseUrl:
                return config.get().categoriesBaseUrl;
            case SbHost.DocumentsBaseUrl:
                return config.get().documentsBaseUrl;
            case SbHost.ConsumerBaseUrl:
                return config.get().consumerBaseUrl;
            case SbHost.AdminBaseUrl:
                return config.get().adminBaseUrl;
            case SbHost.SecuritySearchServiceUrl:
                return config.get().securitySearchServiceUrl;
            case SbHost.ClickhouseBaseUrl:
                return config.get().clickhouseBaseUrl;
            default:
                throw new Error('Could not find host name');
        }
    }

    cssTheme$ = this.select('cssTheme');
    get cssTheme() {
        return this.getValue().cssTheme;
    }
}
